// extracted by mini-css-extract-plugin
export var PostPreview = "post-module--PostPreview--3rG4M";
export var PostPreview__title = "post-module--PostPreview__title--36mjU";
export var PostPreview__content = "post-module--PostPreview__content--11s8M";
export var PostPreview__item = "post-module--PostPreview__item--joDE2";